import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const EditImageProduct = ({ setDisableSave, setEditInfoProduct, editInfoProduct }) => {
    const [selectImgProduct, setSelectImgProduct] = useState("");
    const [preview, setPreview] = useState("");

    // const [selectedFile, setSelectedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [showStatus, setShowStatus] = useState(false);
    const [isUploading, setIsUploading] = useState(true);



    const { apiUrl } = useSelector(state => state.api);

    const handleEditImage = (event) => {
        const selectedFile = event.target.files[0];
        setDisableSave(true)
        setSelectImgProduct(selectedFile);
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setPreview("");
        }
        setIsUploading(false);

    };
    // console.log("Selected file:", avatar);

    const handleSubmit = async (event) => {
        event.preventDefault();
        // You can add your own logic here to upload the file to your server or to display the selected image
        try {
            const dataImage = editInfoProduct.product_img;
            const formData = new FormData();
            formData.append('myFilesProducts', selectImgProduct); // note must be correct "myFiles" with <input type="file" name="myFilesAvatar" onChange={handleFileChange} />
            formData.append('dataImage', dataImage); // append additional data
            const response = await axios.post(`${apiUrl}/upload/uploadmultiple/products`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: localStorage.getItem('token')
                },
            });
            setUploadStatus('File uploaded successfully');
            setShowStatus(true);
            setEditInfoProduct(prevState => ({ ...prevState, product_img: response.data })); // update parent state with image URL
        } catch (err) {
            console.log(err);
            if (err.response) {
                // The request was made and the server responded with a status code
                setUploadStatus(`${err.response.data.message}`);
            } else if (err.request) {
                // The request was made but no response was received
                setUploadStatus('File upload failed: No response received from the server');
            } else {
                // Something happened in setting up the request that triggered an Error
                setUploadStatus(`File upload failed: ${err.message}`);
            }
            setShowStatus(true);
            setTimeout(() => setShowStatus(false), 3000);
        } finally {
            setIsUploading(true); // disable the button
            setTimeout(() => {
                setDisableSave(false);
            }, 3000); // DisableSave for 3 seconds
            setTimeout(() => {
                setShowStatus(false);
            }, 5000); //  after 5 seconds
        }
    };

    useEffect(() => {
        if (editInfoProduct) {
            setDisableSave(false)
        }

    }, [setDisableSave, editInfoProduct])
    return (
        <>
            <form onSubmit={handleSubmit}>
                {editInfoProduct && <div className="mb-3">
                    <label htmlFor="avatarInput" className="form-label">
                        Your Product Image
                    </label>
                    <div>
                        <img src={apiUrl + "/" + editInfoProduct.product_img} alt="Product" className="img-thumbnail my-3" width="200" height="200" />
                    </div>
                </div>}

                <div className="mb-3">
                    <label htmlFor="avatarInput" className="form-label">
                        Upload new product images
                    </label>
                    <input
                        type="file"
                        className="form-control"
                        id="productsInput"
                        name="myFilesProducts"
                        accept="image/png, image/jpeg"
                        onChange={handleEditImage}
                    />
                    <div className="form-text">Please select a JPG or PNG file.</div>
                </div>
                {preview && (
                    <img src={preview} alt="Preview" className="img-thumbnail my-3" width="150" height="150" />
                )}
                <br />
                <button type="submit" className="btn btn-primary" disabled={isUploading}>
                    Upload
                </button>
            </form>
            {showStatus && <p class="uploadStatus">{uploadStatus}</p>}
        </>
    );
};

export default EditImageProduct;
